export default __webpack_public_path__ + "static/media/BONE.d51f24eb.png";